<script lang="ts">
	/**
	 * Sends a `/Settings/Admin/*` URL to where that page lives now (see the route table).
	 *
	 * `replace` rather than `push`, so the old URL does not stay in the history as a stop the back
	 * button lands on and bounces off again. The query string travels: the report and analytics
	 * pages keep their filters there, and a bookmarked slice should open as that slice.
	 */
	import { onMount } from 'svelte';
	import { replace, location, querystring } from '../svelte-spa-router';
	import { adminPathFromLegacy } from '../Utilities';

	// NOTE: We need to export `params` to allow the SPA router to get the value
	export let params: any = {};
	// NOTE: silence warning
	params = params;

	onMount(() => {
		const query = $querystring ?? '';
		void replace(`${adminPathFromLegacy($location)}${query.length > 0 ? `?${query}` : ''}`);
	});
</script>
